import React, { ComponentProps } from 'react';
import { asFetchableView, useViewContext } from '../../../_lib/ViewFetcher';
import { Wysiwyg } from '../../../_lib/components/Wysiwyg';
import { ContentParagraph, ContentParagraphModifier } from '../../../_lib/components/ContentParagraph';

type PersonProfileEditHintConfigDefault = { value?: string | undefined; content?: string | undefined };

function PersonProfileEditHintConfigDefault({ value, content }: PersonProfileEditHintConfigDefault) {
  const { noContentMessage } = useViewContext();

  if (!value && !content) {
    return <ContentParagraph modifier={ContentParagraphModifier.PADDING}>{noContentMessage}</ContentParagraph>;
  }
  /* @ts-expect-error -- value and content cannot be undefined here, see if above */
  return <Wysiwyg content={value || content} resourceReferencesToToUrls={{}} />;
}

export const PersonProfileEditHintConfigDefaultView = asFetchableView(PersonProfileEditHintConfigDefault);
export type PersonProfileEditHintConfigDefaultView = ComponentProps<typeof PersonProfileEditHintConfigDefault>;
